import { useTranslation } from "react-i18next";

export default function Verzekering() {
  const { t } = useTranslation("inbraakschade-reparatie");

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[800px] mx-auto px-4 md:px-10 text-center">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight mb-6 md:mb-8">
          {t("verzekering.h2")}
        </h2>
        <div className="flex flex-col gap-5 md:gap-6">
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("verzekering.p1")}
          </p>
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("verzekering.p2")}
          </p>
          <p className="font-geist text-base md:text-lg text-brand-text/80 leading-relaxed">
            {t("verzekering.p3")}
          </p>
        </div>
      </div>
    </section>
  );
}